/**
 * Özet şablonlarının kimlikleri. Modele giden yapı yönergesi sunucuda
 * (web/lib/ai/prompts.ts → summaryTemplatePrompt).
 *
 * Arayüzdeki katalog (ad, açıklama, önizleme, hangi planda açık) burada değil:
 * renderer/src/features/preferences/summaryTemplates.ts içinde. İki taraf
 * yalnızca kimlikler üzerinden buluşuyor; `npm run test:prefs` listelerin
 * ayrışmadığını kontrol ediyor.
 */

export const SUMMARY_TEMPLATE_IDS = [
  'blank',
  'general',
  'team-meeting',
  'one-on-one',
  'interview',
  'sales-bant',
  'customer-success',
  'user-research',
] as const;

export type SummaryTemplateId = (typeof SUMMARY_TEMPLATE_IDS)[number];

export function isSummaryTemplateId(value: unknown): value is SummaryTemplateId {
  return typeof value === 'string' && (SUMMARY_TEMPLATE_IDS as readonly string[]).includes(value);
}
